import React from "react";
import { DrivingEventChart } from "../../../charts";
import NoDrivingEvents from "./NoDrivingEvents";
import PropTypes from "prop-types";

const DrivingEventDistribution = ({ data, lang }) => {
  let componentToRender;
  let hasEvents = false;

  for (var event in data) {
    if (data[event] > 0) {
      hasEvents = true;
      break;
    }
  }

  if (hasEvents) {
    // TODO: add the impacto and colision icons here
    componentToRender = <DrivingEventChart data={data} lang={lang} />;
  } else {
    componentToRender = <NoDrivingEvents lang={lang} />;
  }

  return componentToRender;
};

DrivingEventDistribution.propTypes = {
  data: PropTypes.object.isRequired,
  lang: PropTypes.object.isRequired
};

export default DrivingEventDistribution;



// WEBPACK FOOTER //
// ./src/containers/Driving/DrivingEventVisualizations/DrivingEventDistribution.js